
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appointments",
      function () {
        return require("private-next-pages/appointments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/appointments"])
      });
    }
  